import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import { TableRow, TableSortLabel, withStyles } from "@material-ui/core";
import { useTranslations } from "adapters/i18n";

export const headCells = [
  {
    id: "finalDate",
    labelKey: "common:period",
  },
  {
    id: "active",
    labelKey: "common:status.situation",
  },
];

const PlanningListTableHeader = ({
  classes,
  order,
  orderBy,
  onRequestSort,
}) => {
  const { t } = useTranslations();
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            sortDirection={orderBy === headCell.id ? order : false}
            className={classes.tableCell}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {t(headCell.labelKey)}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell className={classes.tableCellCenter}>
          {t("planning:planning")}
        </TableCell>
        <TableCell className={classes.tableCellCenter}>
          {t("common:actions.edit")}
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

const tableCell = (theme) => ({
  fontFamily: "Roboto",
  textTransform: "uppercase",
  fontSize: 14,
  lineHeight: 1.29,
  color: theme.palette.primary.main,
  backgroundColor: "#e1e1e1",
  maxWidth: "130px",
  padding: "4px 56px 4px 24px",
});

const styles = (theme) => ({
  tableCell: tableCell(theme),
  tableCellCenter: {
    ...tableCell(theme),
    textAlign: "center",
  },
});

export default withStyles(styles)(PlanningListTableHeader);
